const MALE_SEEDS = ['James', 'David', 'Michael', 'Robert', 'William'];
const FEMALE_SEEDS = ['Sarah', 'Emma', 'Olivia', 'Ava', 'Sophia'];

const AVATAR_COLORS = ['#0842A0', '#0D6EAD', '#0890A0', '#0A7E6B', '#6B4EAA'];

const AVATAR_BASE = 'https://jazzhq-website-assets.s3.us-east-1.amazonaws.com';

export const seedToS3Key = (seed) => {
  if (!seed) return null;
  if (typeof seed !== 'string') return null;

  if (seed.startsWith('http://') || seed.startsWith('https://')) {
    return seed;
  }

  const maleIdx = MALE_SEEDS.indexOf(seed);
  if (maleIdx !== -1) return `${AVATAR_BASE}/male${maleIdx + 1}.png`;

  const femaleIdx = FEMALE_SEEDS.indexOf(seed);
  if (femaleIdx !== -1) return `${AVATAR_BASE}/female${femaleIdx + 1}.png`;

  const maleMatch = seed.match(/male(\d+)/i);
  if (maleMatch) return `${AVATAR_BASE}/male${maleMatch[1]}.png`;

  const femaleMatch = seed.match(/female(\d+)/i);
  if (femaleMatch) return `${AVATAR_BASE}/female${femaleMatch[1]}.png`;

  return seed;
};

export const s3KeyToSeed = (s3Key) => {
  if (!s3Key) return null;
  const match = s3Key.match(/male(\d+)/i);
  if (match) {
    const idx = parseInt(match[1]) - 1;
    return MALE_SEEDS[idx] || null;
  }
  const fmatch = s3Key.match(/female(\d+)/i);
  if (fmatch) {
    const idx = parseInt(fmatch[1]) - 1;
    return FEMALE_SEEDS[idx] || null;
  }
  if (MALE_SEEDS.includes(s3Key) || FEMALE_SEEDS.includes(s3Key)) return s3Key;
  return null;
};

export const getAvatarUrl = (input) => {
  if (!input || typeof input !== 'string') return null;

  if (input.startsWith('http://') || input.startsWith('https://')) {
    return input;
  }

  const maleMatch = input.match(/male(\d+)/i);
  if (maleMatch) {
    return `${AVATAR_BASE}/male${maleMatch[1]}.png`;
  }

  const femaleMatch = input.match(/female(\d+)/i);
  if (femaleMatch) {
    return `${AVATAR_BASE}/female${femaleMatch[1]}.png`;
  }

  const maleIdx = MALE_SEEDS.indexOf(input);
  if (maleIdx !== -1) return `${AVATAR_BASE}/male${maleIdx + 1}.png`;

  const femaleIdx = FEMALE_SEEDS.indexOf(input);
  if (femaleIdx !== -1) return `${AVATAR_BASE}/female${femaleIdx + 1}.png`;

  return null;
};

export const getAvatarInitialsStyle = (seed) => {
  if (!seed) return {};
  const colorIdx = (MALE_SEEDS.indexOf(seed) + FEMALE_SEEDS.indexOf(seed) + 1) % AVATAR_COLORS.length;
  return {
    backgroundColor: AVATAR_COLORS[colorIdx],
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
    fontSize: 20,
  };
};

export const getAvatarInitials = (seed) => seed ? seed.charAt(0).toUpperCase() : '?';

export const getMaleAvatarSeeds = () => [...MALE_SEEDS];
export const getFemaleAvatarSeeds = () => [...FEMALE_SEEDS];
